import LearnVisualFrame from "./LearnVisualFrame";
import p from "./visualPalette";

export default function CashConversionVisual({ title, takeaway, caption, data = {} }) {
  const operatingCash = data.operatingCash || "$300M";
  const capitalSpend = data.capitalSpend || "$180M";
  const freeCashFlow = data.freeCashFlow || "$120M";

  return (
    <LearnVisualFrame title={title} takeaway={takeaway} caption={caption}>
      <svg
        viewBox="0 0 760 390"
        role="img"
        aria-label={`${operatingCash} of cash generated by operations minus ${capitalSpend} of capital expenditures leaves ${freeCashFlow} of free cash flow.`}
      >
        <rect x="230" y="24" width="300" height="72" rx="8" fill={p.surface} stroke={p.line} />
        <text x="380" y="52" textAnchor="middle" fontSize="13" fontWeight="850" fill={p.muted}>
          Cash Generated by Operations
        </text>
        <text x="380" y="82" textAnchor="middle" fontSize="27" fontWeight="900" fill={p.ink}>
          {operatingCash}
        </text>

        <line x1="380" y1="98" x2="380" y2="134" stroke={p.line} strokeWidth="2" />

        <rect x="190" y="136" width="380" height="76" rx="8" fill={p.goldWash} stroke={p.gold} />
        <text x="380" y="165" textAnchor="middle" fontSize="14" fontWeight="900" fill={p.ink}>
          Capital Expenditures
        </text>
        <text x="380" y="194" textAnchor="middle" fontSize="25" fontWeight="900" fill={p.ink}>
          - {capitalSpend}
        </text>

        <line x1="380" y1="214" x2="380" y2="252" stroke={p.gold} strokeWidth="3" />
        <path d="M380 252 l-8 -11 h16 z" fill={p.gold} />

        <rect x="230" y="262" width="300" height="72" rx="8" fill="#fff" stroke={p.line} />
        <text x="380" y="290" textAnchor="middle" fontSize="13" fontWeight="850" fill={p.muted}>
          Free Cash Flow
        </text>
        <text x="380" y="320" textAnchor="middle" fontSize="27" fontWeight="900" fill={p.ink}>
          {freeCashFlow}
        </text>

        <rect x="96" y="350" width="568" height="28" rx="14" fill="rgba(34,35,37,0.04)" stroke={p.softLine} />
        <text x="380" y="369" textAnchor="middle" fontSize="12" fontWeight="800" fill={p.muted}>
          Context: operations, sustaining capital, growth spending, capex timing and commodity prices
        </text>
      </svg>
    </LearnVisualFrame>
  );
}
